import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Configuration } from "@react-md/layout";
import { UserProvider } from "./context/user.context";
import { I18nProvider } from "./i18n";

import Layout from "./layouts";

import "./styles/global.scss";
import "@fontsource/roboto";
import "@fontsource/nunito";
// Roboto/Nunito have no Armenian glyphs; these fill in per-glyph via the font stacks.
import "@fontsource-variable/noto-sans-armenian";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Configuration>
        <I18nProvider>
          <UserProvider>
            <Layout />
          </UserProvider>
        </I18nProvider>
      </Configuration>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
